import { FaSpinner } from "react-icons/fa";

function Loading() {
  return (
    <div className="loading-spinner">
      <FaSpinner />
    </div>
  );
}

export default Loading;
